module.exports = __webpack_public_path__ + "3beaf11cdb5d96b34bc7f443608ba6d1.svg";